export enum QueryParams {
  ID = 'id',
  FILTER = 'filter',
  TEMPLATE_ID = 'templateId',
  HIDE_SIDEBAR = 'hideSidebar',
  TEMPLATE_NAME = 'templateName',
  TEMPLATE_NAMESPACE = 'namespace',
  TEMPLATE_NAMESPACE_TYPE = 'namespaceType',
  HTTP_REFERRER = 'http_referrer',
  SELECTED_PROVIDER = 'selectedProvider',
  RETURNED_FROM_LOGIN_PAGE = 'returnedFromLoginPage',
  REF = 'ref',
  FUNNEL_AUTO_REDIRECT = 'funnelAutoRedirect',
  ENTRY_FLOW = 'entry_flow',
}
